import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'customer';

const functions = {
    async get() {
        await this.sync();

        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncDataVersion(tableName);
    },
    async getDetail(key) {
        const currentData = await this.get();
        
        return await DBEngine.getContentDetailByKey(currentData, key);
    },
    async getDetailByLicensePlate(licensePlate, licensePlateProvince) {
        const currentData = await this.get();

        if (currentData.content && currentData.content.length > 0) {
            return currentData.content.find(x => x.licensePlate === licensePlate && x.licensePlateProvince === licensePlateProvince);
        }

        return null
    },
    async save(value) {
        const currentData = await this.get();

        await DBEngine.updateListData(tableName, currentData, value, (value.key ? DBEngine.syncAction().update : DBEngine.syncAction().add));
    },
    async saveCustomerData(licensePlate, licensePlateProvince, distance, carBrand, carModel, carYearSerie, customerFirstName, customerLastName, customerTel, isTakeService) {
        const customerData = await this.getDetailByLicensePlate(licensePlate, licensePlateProvince);

        const saveData = {
            key: customerData ? customerData.key : '',
            licensePlate: licensePlate ? licensePlate : '',
            licensePlateProvince: licensePlateProvince ? licensePlateProvince : '',
            latestRunningDistance: isTakeService ? distance : (customerData ? customerData.latestRunningDistance : '-'),
            carBrand: carBrand ? carBrand : '',
            carModel: carModel ? carModel : '',
            carYearSerie: carYearSerie ? carYearSerie : '',
            customerFirstName: customerFirstName ? customerFirstName : '',
            customerLastName: customerLastName ? customerLastName : '',
            customerTel: customerTel ? customerTel : '',
            latestServiceDate: isTakeService ? new Date() : (customerData ? customerData.latestServiceDate : '')
        };

        await this.save(saveData);
    }
}

export default functions;